import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import ivclass from '../../../../Modules/IVClass';
import GlobalConfig from '../../../../lib/GlobalConfig';
import HeaderConfig from '../../../../constants/header';
import HeaderItemIcon from '../../HeaderItemIcon';
import { IconPlacementType, MenuType } from '../../constant';
import { translate } from '../../../../utils/common';
import IVButton from '@invideoio/uniformd/components/Button';
import ProductAuth from './ProductAuth';
function getIcon(alt) {
    switch (alt) {
        case 'angle right': {
            return HeaderConfig.ANGLE_RIGHT_ICON_MOBILE;
        }
        case 'angle right blue': {
            return HeaderConfig.ANGLE_RIGHT_ICON_BLUE_MOBILE;
        }
    }
}
const Leaf = (props) => {
    const { icon, className, color, name } = props;
    return (_jsxs(React.Fragment, { children: [icon && icon.placement === IconPlacementType.PREFIX && (_jsx(HeaderItemIcon, { icon: getIcon(icon.alt) })), _jsx("span", { className: ivclass(className, color), children: name }), icon && icon.placement === IconPlacementType.SUFFIX && (_jsx(HeaderItemIcon, { icon: getIcon(icon.alt) }))] }));
};
const MenuItem = (props) => {
    const { color, external, icon, name, type, promo, onNext, objectKey, className = '', linkKey, showAuth, authFunctions, } = props;
    let { url } = props;
    const socialLinks = GlobalConfig.social;
    const menuItemProps = { onClick: null };
    if (linkKey && linkKey === '{{header_live_chat}}') {
        menuItemProps.onClick = () => {
            const liveChatElement = document.getElementById('fresh-chat-custom');
            liveChatElement?.click();
        };
    }
    else if (linkKey && linkKey === '{{youtube_header_link}}') {
        url = socialLinks.links['youtube'];
    }
    else if (linkKey && linkKey === '{{instagram_header_link}}') {
        url = socialLinks.links['instagram'];
    }
    const onLogin = showAuth === 'AI' ? authFunctions.onAILogin : authFunctions.onStudioLogin;
    const onSignUp = showAuth === 'AI' ? authFunctions.onAISignUp : authFunctions.onStudioSignUp;
    const loginText = showAuth === 'AI' ? 'AI login' : 'Studio login';
    const signUpText = showAuth === 'AI' ? 'AI sign up' : 'Studio sign up';
    return (_jsx(React.Fragment, { children: !!promo ? (_jsx("div", { className: "iv-flex iv-mb-25", children: _jsx("img", { src: `${GlobalConfig.cdn.SHARED_URL}${promo.url}`, alt: name, height: 130, width: 198 }) })) : (_jsxs(_Fragment, { children: [type === MenuType.NESTED && (_jsx(_Fragment, { children: !showAuth ? (_jsxs(IVButton, { onClick: () => (objectKey ? onNext(objectKey) : ''), className: ivclass('iv-flex', 'iv-items-center'), children: [_jsx("div", { className: className, children: name }), icon && icon.placement === IconPlacementType.SUFFIX && (_jsx(HeaderItemIcon, { icon: getIcon(icon.alt) }))] })) : (_jsx(ProductAuth, { onLogin: onLogin, onSignUp: onSignUp, loginText: loginText, signUpText: signUpText })) })), type === MenuType.LEAF &&
                    ((linkKey === '{{header_live_chat}}' && (_jsx("span", { className: ivclass('iv-flex', 'iv-items-center'), ...menuItemProps, children: _jsx(Leaf, { icon: icon, className: className, color: color, name: name }) }))) ||
                        (url && (_jsx("a", { className: ivclass('iv-flex', 'iv-items-center'), href: translate(`host_url`, { host_url: GlobalConfig.HOST_URL }, { default: url }), target: external ? '_blank' : '_self', rel: "noreferrer", children: _jsx(Leaf, { icon: icon, className: className, color: color, name: name }) }))))] })) }));
};
export default MenuItem;
